module.exports = __webpack_public_path__ + "static/media/bliksem.34a298c0.png";